<script>
import { format } from 'date-fns/fp'
import EventsCalendarMixin from '@events/mixins/events-calendar-mixin'

export default {
  name: 'EventCalendar',
  mixins: [EventsCalendarMixin],
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    currentDate: {
      type: Date,
      required: true,
    },
  },
  methods: {
    formatDate: format,
    currentDateNow() {
      return this.currentDate
    },
  },
}
</script>

<template>
  <div
    class="calendar-events w-full bg-white rounded-xl shadow-box pl-8 pr-12 py-8 mb-4.5"
  >
    <div class="flex justify-between">
      <div class="text-blue-darker">
        <span class="text-4.5xl"
          >{{ formatDate('MMMM', currentDateNow()) }}
        </span>
        <span class="text-3xl">{{ formatDate('Y', currentDateNow()) }}</span>
      </div>
      <div class="leading-2xl align-middle">
        <button
          class="inline-block align-middle focus:outline-none"
          @click="previous"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="18"
            viewBox="0 0 9.677 18"
          >
            <g
              id="Group_85"
              data-name="Group 85"
              transform="translate(10) rotate(90)"
            >
              <path
                id="Path_37"
                data-name="Path 37"
                d="M8.919,9.677,0,.757.757,0,8.919,8.162,17.081,0l.758.757Z"
                fill="#069bd7"
              />
            </g></svg
        ></button>
        <button
          class="inline-block align-middle focus:outline-none ml-4"
          @click="next"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="18"
            viewBox="0 0 9.677 18"
          >
            <g
              id="Group_84"
              data-name="Group 84"
              transform="translate(0 18) rotate(-90)"
            >
              <path
                id="Path_37"
                data-name="Path 37"
                d="M8.919,9.677,0,.757.757,0,8.919,8.162,17.081,0l.758.757Z"
                fill="#069bd7"
              />
            </g></svg
        ></button>
      </div>
    </div>
    <div class="week-day-names">
      <span class="">Su.</span>
      <span class="">Mo.</span>
      <span class="">Tu.</span>
      <span class="">We.</span>
      <span class="">Th.</span>
      <span class="">Fr.</span>
      <span class="">Sa.</span>
    </div>
    <!-- this key is not ideal -->
    <div
      v-for="(days, index) in weeks"
      :key="index"
      class="week-days"
      :class="[index >= weeks.length - 1 ? 'pb-1' : '']"
    >
      <button
        v-for="(day, i) in days.days"
        :key="day.number + day.hasEvents + i"
        class="other-month focus:outline-none"
        :class="[
          day.isCurrentMonth ? 'current-month' : 'other-month',
          day.hasEvents ? 'has-events' : '',
        ]"
        @click="filterEvents(day)"
        >{{ day.number }}<span v-show="day.hasEvents" class="bullet"></span
      ></button>
    </div>
  </div>
</template>
